export const GROUP_RECEIVED = 'receiveGroup'

export const receiveGroup = group => ({
  type: GROUP_RECEIVED,
  payload: group
})



// WEBPACK FOOTER //
// ./src/Group/actions.js